
import React from 'react';
import { FiMapPin } from 'react-icons/fi';
import { ProcessHeader } from '../../../../components';
import './styles.css';

function useSpaceAddresses(commands){

    const selectAddress = (address) => {
      commands.order.changeDataAttributes({
      deliveryAddr: address,
      deliveryAddrId:address.id,
      deliveryValue: address.cost
    });
    commands.process.goToStep(3);
  }; 

  const goBack = () => commands.process.previousStep();
  return ({
    eventHandlers:{
      selectAddress,
      goBack
    },
  });
}

export default function SpaceAddresses(props) {
  const {commands, sharedStates, remoteStates} = props;
  const {eventHandlers} = useSpaceAddresses(commands);
  
    return (
      <section className="step-container">
        <ProcessHeader goBackAction={eventHandlers.goBack}/>
        <h1 className="step-title">
           Em qual dos endereços você prefere retirar o produto?
         </h1>
        {
          remoteStates.addresses?.map((item, index) => (
          <div className="step-options-items" key={index}>
            <button
              type="button"
              onClick={() => eventHandlers.selectAddress(item)}
              className={`step-option-select ${item.id === sharedStates?.order?.deliveryAddrId && 'step-option-selected'}`}
            >
            <div className='step-option-selector'>
             <div className="step-option-delivery-values-box">
              <div className="step-option-icon">
                <FiMapPin size={32} strokeWidth="0.8" />
              </div>
              <p className="delivery-value">{item.neighborhood}</p>
             </div>

              <div className="step-option-text">
                <p>{`${item.street}, ${item.number} ${item.complement ? `(${item.complement})` : ''}`}</p>
                <p>{`${item.city}/${item.uf}`}</p>
                <p>{`CEP: ${item.zipCode}`}</p>
              </div>
              </div>
            </button>
          </div>
        ))}
      </section>
    );
}

